<template>
  <div>
    <div class="overlay"></div>
    <div class="modal_fixed">
      <div class="popup_box ungame_balance_popup modal_cont" id="">

        <img src="static/images/store/icon-close-back-popup.svg" class="btn_close">

        <h1>{{ getTranslations.home_modal_unlocked_you_have }} {{ userDetails.availableGames }} {{
          getTranslations.home_modal_unlocked_unlocked_games }}</h1>

        <h6>{{ getTranslations.home_modal_unlocked_play_them }}!</h6>

        <img src="static/images/popups/icon-Achievement.png" class="ungame_bal_img">

        <p>{{ getTranslations.home_modal_unlocked_unlocked_games_after }} <span>{{ getTranslations.home_modal_unlocked_end_time  }}</span>
          {{ getTranslations.home_modal_unlocked_and_converts_to }}
          <span>{{ getTranslations.home_modal_unlocked_game }}</span></p>

        <button type="" @click.prevent="openNewGameModal">{{ getTranslations.home_modal_unlocked_new_game_button }}
        </button>
      </div>
    </div>
    <div class="circle_background popup_circle_bg">
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex';
import modals from '@/common/modals';
import NewGameModal from '../pregame/NewGameModal';

export default {
  name: 'unlocked-games-modal',
  components: { NewGameModal },
  methods: {
    ...mapMutations('common', [
      'storeModalForHomePage',
    ]),
    openNewGameModal() {
      this.storeModalForHomePage(NewGameModal);
      modals.showHideModal(this);
    },
  },
  computed: {
    ...mapState('common', [
      'userDetails',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/unlockedgames/UnlockedGamesModal.vue